<template>
    <div id="currentTokenCookie">
    </div>
</template>

<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import TEST from "./backend/policiesandforms/test";
    var self;
    export default {
        name: 'COOKIE',
        mixins: [SessioMixin],
        components: {

        },
        data() {
            return {
                token: '',
            }
        },
        computed: {

        },
        watch: {

        },
        beforeMount: function () {
            self = this;
            self.token = localStorage.getItem("api_token");
        },
        mounted: function () {
            self.getBuildVersion();
            $('#currentTokenCookie').html(self.token);
            var msg = window.parent.document.getElementById("logintoken");
            msg.innerHTML = "update from iframe";
            //alert($(document, parent.window.document).find("#logintoken").html());
            //alert(self.token);
        },
        methods: {

        },
    }
</script>




// WEBPACK FOOTER //
// src/components/Cookie.vue